// Keep the namespace centralized in one TypeGen-friendly file.
// Sanity TypeGen cannot statically evaluate imported helpers or env-expression chains here.
export const SCHEMA_NAMESPACE = 'portaNZ';

export const namespaceType = (typeName: string) => `${SCHEMA_NAMESPACE}.${typeName}`;

export const namespaceDocumentId = (documentId: string) => `${SCHEMA_NAMESPACE}.${documentId}`;
